import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";
import { GetNewsDTO, INewsItem } from "./models";

export const GetNewsApi = async (dto: GetNewsDTO) => {
  const { data } = await api.post<INewsItem>(
    API_ROUTES.NEWS_ITEM,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};
